import { render } from "./alert.vue?vue&type=template&id=37515cbc"
import script from "./alert.vue?vue&type=script&lang=js"
export * from "./alert.vue?vue&type=script&lang=js"

import "./alert.vue?vue&type=style&index=0&id=37515cbc&lang=scss"
script.render = render

export default script